/* istanbul ignore file */
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-offer-content',
  templateUrl: './offer-content.component.html',
  styleUrls: ['./offer-content.component.scss']
})
export class OfferContentComponent {
  @Input() offer: string;
  @Input() contractId: string;
  @Input() userEmail: string;
  @Input() userType: string;
  @Input() usersOnContract: number;
}
